import { render, staticRenderFns } from "./ConfirmationTypeAdditionals.vue?vue&type=template&id=14e6b20a&"
import script from "./ConfirmationTypeAdditionals.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ConfirmationTypeAdditionals.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ConfirmationTypeAdditionals.vue?vue&type=style&index=0&id=14e6b20a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports